import React, { useEffect, useContext } from "react";
import Carousel from "react-multi-carousel";
import PopularRoomCard from "../../VibehutUI/Card/PopularRoomCard";
import { getHomePopularRooms } from "../../actions/roomAction";
import { StoreContext } from "../../Context/StoreContext";
import Previous from "../../VibehutUI/Icons/Previous";
import Next from "../../VibehutUI/Icons/Next";
import RoomCardSkeleton from "../../VibehutUI/Skeletons/RoomCardSkeleton";
import NotificationUpdate from "../../VibehutUI/Notification/NotificationUpdate";

function PopularRooms({ sliderWidth }) {
  const { state, dispatch } = useContext(StoreContext);

  const {
    auth,
    room: {
      homePopularRooms,
      isFetchingPopRoom,
      isMoreHomePopRoom,
      homePopRoomOffset,
      isMoreHomePopularRoomFetching,
    },
  } = state;
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 769 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 768, min: 641 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
    },
  };

  useEffect(() => {
    if (!homePopularRooms.length > 0) {
      getHomePopularRooms(auth?.user?.token, dispatch, false, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const ButtonGroup = ({ next, previous, ...rest }) => {
    const {
      carouselState: { currentSlide },
    } = rest;

    return (
      <div className="absolute right-1 top-9">
        <span className="flex space-x-3">
          <span onClick={() => previous()} className="cursor-pointer">
            <Previous disabled={currentSlide === 0} />
          </span>

          <span
            onClick={() => {
              if (isMoreHomePopularRoomFetching) {
                return;
              }
              if (
                rest?.carouselState?.totalItems - currentSlide <= 5 &&
                isMoreHomePopRoom
              ) {
                getHomePopularRooms(
                  auth?.user?.token,
                  dispatch,
                  isMoreHomePopRoom,
                  homePopRoomOffset,
                );
              }
              next();
            }}
            className="cursor-pointer"
          >
            <Next />
          </span>
        </span>
      </div>
    );
  };

  const height =
    homePopularRooms.length > 0 && homePopularRooms[0]?.users?.length > 0
      ? "h-[272px]"
      : "h-60";
  return (
    <>
      <div className="relative" style={{ width: sliderWidth }}>
        <div className="pt-8">
          <p className="font-bold md:text-2xl text-xl text-darkNight dark:text-frescoWhite px-2">
            Popular Rooms
          </p>
          {!isFetchingPopRoom ? (
            <div className="pt-7">
              {homePopularRooms?.length > 0 && (
                <Carousel
                  responsive={responsive}
                  renderButtonGroupOutside={true}
                  itemClass={`px-1.5 ${height}`}
                  containerClass={height}
                  className={height}
                  arrows={false}
                  draggable={false}
                  swipeable={true}
                  shouldResetAutoplay={false}
                  customButtonGroup={<ButtonGroup />}
                >
                  {homePopularRooms.map((item) => (
                    <div key={item._id}>
                      <PopularRoomCard item={item} />
                      <NotificationUpdate
                        roomId={item._id}
                        totalSubscribedUsers={item?.subscriptions.count}
                        roomOwner={item?.owner}
                        showSubscriptionBell={false}
                        showChatIcon={false}
                        allSubscribers={
                          item?.allSubscribers ? item?.allSubscribers : []
                        }
                      />
                    </div>
                  ))}
                </Carousel>
              )}
            </div>
          ) : (
            <RoomCardSkeleton totalCard={sliderWidth > 1200 ? 4 : 3} />
          )}
        </div>
      </div>
    </>
  );
}

export default PopularRooms;
